import store from '@/store'
import { trackCheckoutError } from '@/utils/checkoutAnalytics'

// Дедуп ошибок валидации: validation_error улетает один раз на поле за сессию
// модуля (TC-21). Сбрасывается естественно при перезагрузке страницы.
const _firedValidationFields = new Set()
function reportValidationError(field, message) {
  if (_firedValidationFields.has(field)) return
  _firedValidationFields.add(field)
  trackCheckoutError({
    step: 'delivery',
    errorType: 'validation_error',
    errorMessage: message ? `${field}: ${message}` : field,
  })
}

export function validateField(
  group,
  field,
  value,
  getCountryCode,
  addressInfo,
  $t,
  fieldsConfig,
  getFieldPropertyValue
) {
  if (value === null) value = ''

  value = value?.trim().replace(/\s\s+/g, ' ')

  if (getCountryCode === 'PL' && field === 'POSTINDEX') {
    let numbers = value.replace(/\D/g, '')

    if (numbers.length <= 2) {
      value = numbers
    } else if (numbers.length > 2 && numbers.length <= 5) {
      value = `${numbers.slice(0, 2)}-${numbers.slice(2)}`
    } else if (numbers.length > 5) {
      value = numbers.slice(0, 6)
    }

    addressInfo.PROFILE[field] = value
  }

  if (getCountryCode === 'LV' && field === 'POSTINDEX') {
    const raw = value.toUpperCase().replace(/\s/g, '')
    const digits = raw.replace(/^LV-?/i, '').replace(/\D/g, '')

    const four = digits.slice(0, 4)
    value = `LV-${four}`
    addressInfo.PROFILE[field] = value
  }

  store.commit('setFieldError', { field, error: false })

  const isRequired = getFieldPropertyValue(group, field, 'required')

  if (isRequired) {
    if (!value || !value.length) {
      store.commit('setFieldError', { field, error: $t('fill_that_field') })
      reportValidationError(field, $t('fill_that_field'))
    }
  }

  if (getCountryCode === 'LV' && field === 'POSTINDEX') {
    if (value.length < 7) {
      store.commit('setFieldError', { field, error: $t('fill_that_field') })
      reportValidationError(field, $t('fill_that_field'))
    } else {
      store.commit('setFieldError', { field, error: false })
    }
  }

  validateAddressField(
    value,
    false,
    addressInfo,
    fieldsConfig,
    $t,
    getCountryCode
  )
}

export function validateAddressField(
  value,
  fromGMap = false,
  addressInfo,
  fieldsConfig,
  $t,
  getCountryCode
) {
  if (fromGMap) {
    setTimeout(() => {
      // срабатывает сначала валидация, а потом асинхронная операция по получению гугл объекта, refactoring
      validateAddressFieldInside(
        value,
        addressInfo,
        fieldsConfig,
        $t,
        getCountryCode
      )
    }, 200)
  } else
    validateAddressFieldInside(
      value,
      addressInfo,
      fieldsConfig,
      $t,
      getCountryCode
    )
}

export function validateAddressFieldInside(
  value,
  addressInfo,
  fieldsConfig,
  $t,
  getCountryCode
) {
  if (!value || !value.length) {
    if (addressInfo.PROFILE.CITY in addressInfo) {
      addressInfo.PROFILE.CITY = null
    }

    if (addressInfo.PROFILE.STREET in addressInfo) {
      addressInfo.PROFILE.STREET = null
    }

    if (addressInfo.PROFILE.BUILD in addressInfo) {
      addressInfo.PROFILE.BUILD = null
    }
  }

  // проверка на заполнение скрытых обязательных полей
  const notFilled = []
  const notFilledLabels = []
  let r = true

  if (fieldsConfig.ADDRESS_INFO_FIELDS) {
    for (const item of fieldsConfig.ADDRESS_INFO_FIELDS) {
      if (
        item.required &&
        (item.type === 'text' || item.type === 'number') &&
        !['FIO', 'PHONE', 'EMAIL'].includes(item.name)
      ) {
        if (
          typeof addressInfo.PROFILE[item.name] === 'undefined' &&
          !notFilled.includes(item.name)
        ) {
          notFilled.push(item.name)
          notFilledLabels.push(item.label)
        }

        const validFieldLength =
          getCountryCode === 'LV' && item.name === 'POSTINDEX' ? 6 : 0

        if (
          Boolean(r) &&
          addressInfo.PROFILE[item.name] !== null &&
          addressInfo.PROFILE[item.name]?.trim() &&
          addressInfo.PROFILE[item.name]?.trim().length > validFieldLength
        ) {
          r = Boolean(
            r &&
            addressInfo.PROFILE[item.name]?.trim() &&
            addressInfo.PROFILE[item.name]?.trim().length > 0
          )

          if (!r && !notFilled.includes(item.name)) {
            notFilled.push(item.name)
            notFilledLabels.push(item.label)
          }
        } else {
          if (!notFilled.includes(item.name)) {
            notFilled.push(item.name)
            notFilledLabels.push(item.label)
          }
        }
      }
    }
  } else {
    console.log('wrong fieldsConfig')
  }

  if (notFilled.length > 0) {
    store.commit(
      'setCourierAddressFieldError',
      $t('hidden_fields_error') + ': ' + notFilledLabels.join(', ')
    )
    reportValidationError(
      'courierAddressField',
      'missing: ' + notFilled.join(',')
    )
  } else {
    store.commit('setCourierAddressFieldError', false)

    return true
  }

  return false
}

export function getMissingAddressFields(fieldsConfig, addressProfile) {
  const missingFields = []
  if (fieldsConfig?.ADDRESS_INFO_FIELDS) {
    for (const item of fieldsConfig.ADDRESS_INFO_FIELDS) {
      if (
        item.required &&
        (item.type === 'text' || item.type === 'number') &&
        !['FIO', 'PHONE', 'EMAIL'].includes(item.name)
      ) {
        const val = addressProfile[item.name]
        if (!val || (typeof val === 'string' && !val.trim())) {
          missingFields.push(item.name.toLowerCase())
        }
      }
    }
  }
  return missingFields
}
